<template>
  <div class="bg-white border border-outline-color round-4 mx-3 mb-2 p-3">
    <h4 class="text-size-14 text-weight-500">
      {{ officeName }}
    </h4>
    <p class="text-size-14 mt-1 text-break">{{ evaluation.thankYouMessage }}</p>
    <EvaluationGroup :evaluation="evaluation" class="mt-2" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import EvaluationGroup from "@/components/organisms/orders/EvaluationGroup.vue";
import { EvaluationByOffice } from "@/types/order/EvaluationByOffice";

@Component({
  components: {
    EvaluationGroup
  }
})
export default class ApplicationsEvaluation extends Vue {
  @Prop({
    type: String,
    required: true
  })
  officeName!: string;

  @Prop({
    type: Object,
    required: true
  })
  evaluation!: EvaluationByOffice;
}
</script>
